import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import DashboardLayout from './components/DashboardLayout';
import LeadsTable from './components/LeadsTable';
import AccountsTable from './components/AccountsTable';
import DealsTable from './components/DealsTable';
import OrdersTable from './components/OrdersTable';
import LeadForm from './components/LeadForm';
import Dashboard from './components/Dashboard';
import TenderTable from './components/TenderTable';
import ManageTender from './components/ManageTender';
import ProtectedPage from './components/ProtectedPage';
import { AuthProvider, useAuth } from './components/AuthContext';
import CalendarView from './components/CalendarView';
import TravelTable from './components/TravelTable';
import SalesTrackerTable from './components/SalesTrackerTable';
import QuotationBuilder from './components/QuotationBuilder';
import ProjectTable from './components/ProjectTable';
import EmailTemplatesTable from './components/email/EmailTemplatesTable';
import EmailDashboard from './components/email/EmailDashboard';
import ExistenceCheckPage from './components/ExistenceCheckPage';
import CostingTable from './components/CostingTable';
import InventoryModule from './components/InventoryModule';
import StockManagement from './components/StockManagement';
import ExpenseRequestTable from './components/ExpenseRequestTable';
import NomenclatureManager from './components/NomenclatureManager';

const AppRoutes = () => {
  const { user } = useAuth();

  return user ? (
    <DashboardLayout>
      <Routes>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="view-leads" element={<LeadsTable />} />
        <Route path="view-accounts" element={<AccountsTable />} />
        <Route path="view-deals" element={<DealsTable />} />
        <Route path="view-orders" element={<OrdersTable />} />
        <Route path="add-lead" element={<LeadForm />} />
        <Route path="calendar" element={<CalendarView />} />
        <Route path="sales-tracker" element={<SalesTrackerTable />} />
        <Route
          path="nomenclature"
          element={
            <ProtectedPage pageKey="Nomenclature">
              <NomenclatureManager />
            </ProtectedPage>
          }
        />
        <Route path="quotation-builder" element={<QuotationBuilder />} />
        <Route path="projects" element={<ProjectTable />} />
        <Route
          path="costing"
          element={
            <ProtectedPage pageKey="Costing">
              <CostingTable />
            </ProtectedPage>
          }
        />

        <Route
          path="expense-requests"
          element={
            <ProtectedPage pageKey="Expense Requests">
              <ExpenseRequestTable />
            </ProtectedPage>
          }
        />
  
        <Route
          path="inventory"
          element={
            <ProtectedPage pageKey="Inventory">
              <InventoryModule />
            </ProtectedPage>
          }
        />

        <Route
          path="stock-management"
          element={
            <ProtectedPage pageKey="Stock Management">
              <StockManagement />
            </ProtectedPage>
          }
        />
        

        <Route
          path="email-templates"
          element={
            <ProtectedPage pageKey="Email">
              <EmailTemplatesTable />
            </ProtectedPage>
          }
        />
        <Route
          path="email-dashboard"
          element={
            <ProtectedPage pageKey="Email">
              <EmailDashboard />
            </ProtectedPage>
          }
        />

        {/* ✅ NEW: Existence Check page (controlled by CRM Login sheet Page Access) */}
        <Route
          path="existence-check"
          element={
            <ProtectedPage pageKey="Existence Check">
              <ExistenceCheckPage />
            </ProtectedPage>
          }
        />

        {/* ✅ Travel route with access control */}
        <Route
          path="view-travel"
          element={
            <ProtectedPage pageKey="Travel">
              <TravelTable />
            </ProtectedPage>
          }
        />

        {/* ✅ Tender routes with access control */}
        <Route
          path="tender"
          element={
            <ProtectedPage pageKey="Tender">
              <TenderTable />
            </ProtectedPage>
          }
        />
        <Route
          path="manage-tender"
          element={
            <ProtectedPage pageKey="Manage Tender">
              <ManageTender />
            </ProtectedPage>
          }
        />
      </Routes>
    </DashboardLayout>
  ) : (
    <Routes>
      <Route path="*" element={<LoginPage />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/*" element={<AppRoutes />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
